import { IContentSource } from "../../domain/drawing";
import { IClipboardService, IClipboardAccessible } from "../../domain/system";
import { ClipboardRepository } from "./ClipboardRepository";
import { ClipboardAccessor } from "./ClipboardAccessor";
import { ClipboardWatcher } from "./ClipboardWatcher";

export class ClipboardService implements IClipboardService {
  private readonly _repository: ClipboardRepository = new ClipboardRepository();

  createAccessor(): IClipboardAccessible {
    const accessor = new ClipboardAccessor(
      new ClipboardWatcher<string>(
        (count, latestSequenceNo) => this._repository.getLatestTexts(count, latestSequenceNo),
        0,
        () => this._repository.clearTexts(),
        (sequenceNo) => this._repository.removeTexts(sequenceNo)),
      new ClipboardWatcher<IContentSource>((count, latestSequenceNo) => this._repository.getLatestImages(count, latestSequenceNo))
    );
    ClipboardService._accessors.push(accessor);
    return accessor;
  }

  private static _accessors: ClipboardAccessor[] = [];
  private static _timer: any;

  async start(): Promise<void> {
    if (!ClipboardService._timer) {
      ClipboardService._timer = setInterval(() => ClipboardService.watchClipboard(), 500);
    }
  }

  private static watchClipboard(): void {
    this.readTextFromClipboard()
    .then(text => {
      ClipboardRepository.registerText(text);
      for (const accessor of ClipboardService._accessors) {
        accessor.textWatcher.poll();
      }
    })
    .catch(e => {
      // DO NOTHING
    });
  }

  private static async readTextFromClipboard(): Promise<string> {
    if ((window as any).clipboardData) {
      // IEの場合
      // 毎回確認ダイアログが出てしまう
      // 「信頼済みサイト」にサイトを登録したうえで、「登録済みサイト」の「スクリプトによる貼付け処理の許可」を有効にしておけば出ない
      const result = (window as any).clipboardData.getData("Text");
      return result // clipboardが空の場合はnull.(IE11動作.)
        ? result
        : "";
    } else if ((navigator as any).clipboard) {
      // Chromeの場合
      // 出てくる確認ダイアログでOKを押せば以降は確認ダイアログは出なくなる
      // Chromeがフォアグラウンドに無いと取得できない模様...(フォアグラウンドにいないと例外が発生してる.)
      try {
        return (navigator as any).clipboard.readText(); // clipboardが空の場合は空文字列.
      } catch {
        return "";  // chromeがフォアグラウンドじゃない場合例外.初回文字列判定のため空文字列を返す.(初回時にバックグラウンドだった場合は救えないが方法がないので諦め.)
      }
    }
    return "";
  }
}
